import classNames from 'classnames';
import React from 'react';

import {assert} from 'Asserts';
import TimeEditableClass from 'notebook/protocols/editor/TimeEditable';
import {ElementMouseEvent} from 'util/Types';

import {EditHelpers} from '../timers/TimerConstants';

interface TimeDisplayProps {
  editing: boolean;
  editHelpers?: EditHelpers;
  msLeft: number;
  msTotal: number;
  finalizeTimer: () => void;
  toggleStart: (e: ElementMouseEvent) => void;
  renderProgress: Function;
}

const TimeDisplay = (props: TimeDisplayProps): JSX.Element => {
  if (props.editing) {
    const {editHelpers} = props;
    assert(editHelpers?.cid != null, 'Expected non-null cid');
    return (
      <TimeEditableClass
        time_seconds={props.msTotal / 1000}
        cid={editHelpers.cid}
        updateTimeHandler={editHelpers.updateTimeHandler}
        setSelection={editHelpers.setSelection}
        storeState={editHelpers.storeState}
        restoreState={editHelpers.restoreState}
        enterHandler={props.finalizeTimer}
      />
    );
  }
  function pad(val: number): string {
    if (val < 10) {
      return `0${val}`;
    } else {
      return `${val}`;
    }
  }
  const secondsLeft = props.msLeft / 1000;
  let minutes = Math.floor(secondsLeft / 60);
  const seconds = Math.floor(secondsLeft % 60);
  const hours = Math.floor(minutes / 60);
  minutes %= 60;
  const mainText = `${pad(hours)}:${pad(minutes)}`;
  const smallText = `:${pad(seconds)}`;
  return (
    <div
      className={classNames('time-display', {'out-of-time': props.msLeft === 0})}
      onClick={props.toggleStart}
    >
      {props.renderProgress()}
      {mainText}
      <span className="time-small">{smallText}</span>
    </div>
  );
};

export default TimeDisplay;
